<template>
  <div class="popup">
    <div class="popup-content">
      {{ content }}
    </div>
    <div class="btnGrp">
      <div class="jcse">
        <b-form-checkbox type="checkbox" v-model="dontShowToday">
          오늘 하루 보지 않기
        </b-form-checkbox>
        <b-button class="empty-delBtn mr0" @click="closeModal">
          <i class="fa fa-window-close"></i>닫기
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dontShowToday: false,
      title: null,
      content: null,
    };
  },
  created() {
    this.content = this.defaultInfo.content;
    this.title = this.defaultInfo.title;
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      return `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()}`;
    },
    closeModal() {
      if (this.dontShowToday) {
        localStorage.setItem("dontShowPopupToday", this.getTodayDate());
      }
      this.$bvModal.hide("noticePopup");
    },
  },
};
</script>

<style lang="scss">
#noticePopup .modal-dialog {
  max-width: 400px !important;
}

.popup-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  font-size: 14px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/NoticePopup.vue